/* istanbul ignore file */

import * as Sentry from '@sentry/react'
import axios from 'axios'

import { helpers, httpStatuses } from '@reveni-io/reveni-ui'

const sendErrorToSentry = err => {
  if (import.meta.env.VITE_SENTRY_ENVIRONMENT && err.response) {
    let url = err.response?.request?.responseURL?.replace(/(\w){32}/g, ':uuid')

    const newError = new Error(url)

    newError.name = `Error ${err.response?.status}: ${url}`
    newError.stack = `Error ${err.response?.status}: ${url}`

    Sentry.captureException(newError, {
      extra: {
        body: err.request?.__sentry_xhr__,
        localStorage: localStorage,
        response: err.response.data,
      },
    })
  }
}

const addJwtToAuthorizationHeader = config => {
  if (!config.url.includes('/stores')) {
    try {
      if (localStorage.jwt || window.reveniGuestToken) {
        config.headers['Authorization'] = `Bearer ${localStorage.jwt || window.reveniGuestToken}`
      }
      // eslint-disable-next-line
    } catch {} //without catch because is to handle errors if the user is in incognito mode active.
  }
}

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    error.errorMessage = helpers.getErrorMessage(error)
    sendErrorToSentry(error)
    if (error?.response?.status === httpStatuses.unauthorized) {
      localStorage.clear()
    }
    return Promise.reject(error)
  }
)

axios.interceptors.request.use(config => {
  addJwtToAuthorizationHeader(config)
  return config
})
